import { useEffect, useState } from 'react';
import { Icon } from '@/ui/icons/Icon';
import styles from './DerogationWarning.module.scss';

export const DerogationWarning = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Small delay to trigger fade-in animation after mount
    const timer = requestAnimationFrame(() => {
      setIsVisible(true);
    });
    return () => cancelAnimationFrame(timer);
  }, []);

  return (
    <div className={`${styles.warning} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.arrow}>
        <Icon name="vector-up" />
      </div>
      <span className={styles.title}>Grad de îndatorare depășit!</span>
      <span className={styles.description}>
        Ofertele noastre sunt personalizate în funcție de scorul și istoricul
        tău creditar, precum și de gradul tău curent de îndatorare. Suma maximă
        pe care ți-o oferim ia în calcul sănătatea ta financiară. De aceea, îți
        recomandăm ca rata lunară totală să nu depășească 40% din veniturile
        tale.
      </span>
    </div>
  );
};
